import { ClassProvider, LOCALE_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export function provideLocaleId(): ClassProvider {
    const provider = {
        provide: LOCALE_ID,

        useClass: class extends String {
            constructor(private translate: TranslateService) {
                super();
            }

            public override toString(): string {
                return this.translate.currentLang;
            }

            public override valueOf(): string {
                return this.translate.currentLang;
            }
        },

        deps: [TranslateService],
    };

    return provider;
}
